const MARKET_PARAMETER: string = "market";
const BRAND_PARAMETER: string = "brand";
const LANG_PARAMETER: string = "lang";
const USER_PARAMETER: string = "eulid";
const USER_FALLBACK_PARAMETER: string = "ulidh";
const MOCK_TEST_PARAMETER: string = "mockTest";
const SCR_PARAMETER: string = "scr";

class QueryParameters {
  private queryParams: URLSearchParams;

  constructor() {
    this.queryParams = new URLSearchParams(window.location.search);
  }

  getBrand(): string {
    return this.queryParams.get(BRAND_PARAMETER) ?? "";
  }

  getMarket(): string {
    return this.queryParams.get(MARKET_PARAMETER) ?? "";
  }

  getLang(): string {
    return this.queryParams.get(LANG_PARAMETER) ?? "";
  }

  getUser(): string {
    return (
      this.queryParams.get(USER_PARAMETER) ?? this.queryParams.get(USER_FALLBACK_PARAMETER) ?? ""
    );
  }

  getMockTest(): string {
    return this.queryParams.get(MOCK_TEST_PARAMETER) ?? "";
  }

  getScr(): string {
    return this.queryParams.get(SCR_PARAMETER) ?? "";
  }

  buildUrlParamsForTelemetry(): string {
    const params = {
      market: this.getMarket(),
      brand: this.getBrand(),
      lang: this.getLang()
    };

    return new URLSearchParams(params).toString();
  }
}

export default QueryParameters;
